export default "__VITE_ASSET__fc983108__"